module.exports = __webpack_public_path__ + "static/media/burn-success.e40e1297.png";